import { Link } from "react-router-dom";
import { Stethoscope, Lightbulb, Rocket, GraduationCap, PenLine, ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { EXPERTISE } from "../../lib/content";

const ICONS = { Stethoscope, Lightbulb, Rocket, GraduationCap, PenLine };

export default function AreasOfExpertise() {
  return (
    <section id="expertise" className="relative py-24 md:py-36 bg-surface/40 border-y border-gold/10" data-testid="expertise-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-[0.25em] text-gold">Areas of Expertise</span>
            <h2 className="font-serif text-4xl md:text-6xl font-light mt-4 leading-tight text-foreground">
              Where I create <span className="text-gradient-gold italic">measurable value.</span>
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXPERTISE.map((e, i) => {
            const Icon = ICONS[e.icon] || Lightbulb;
            return (
              <Reveal key={e.title} delay={(i % 3) * 0.08}>
                <div className="group h-full rounded-2xl border border-gold/15 bg-card p-8 hover:border-gold/45 transition-colors duration-500" data-testid={`expertise-card-${i}`}>
                  <div className="w-14 h-14 rounded-xl border border-gold/30 flex items-center justify-center text-gold mb-6 group-hover:bg-gold group-hover:text-ink transition-colors duration-300">
                    <Icon size={24} />
                  </div>
                  <h3 className="font-serif text-2xl text-foreground leading-snug mb-3">{e.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{e.body}</p>
                </div>
              </Reveal>
            );
          })}

          {/* CTA card */}
          <Reveal delay={0.16}>
            <Link
              to="/practice"
              data-testid="expertise-cta"
              className="group h-full rounded-2xl border border-royal/30 bg-[radial-gradient(ellipse_at_bottom_right,rgba(147,51,234,0.18),transparent_65%)] p-8 flex flex-col justify-between hover:border-royal/60 transition-colors duration-500"
            >
              <h3 className="font-serif text-2xl md:text-3xl text-foreground leading-snug">
                Explore consultations, impact & research
              </h3>
              <span className="mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-[0.12em] text-gold">
                See my practice <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
